import { render, staticRenderFns } from "./appDetails.vue?vue&type=template&id=96e41058&"
import script from "./appDetails.vue?vue&type=script&lang=js&"
export * from "./appDetails.vue?vue&type=script&lang=js&"
import style0 from "./appDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports